export const searchCollections = (query: string) => {
  const params = new URLSearchParams({
    q: query,
    "resources[type]": "collection",
    "resources[limit]": "5",
    "resources[limit_scope]": "each",
  });
  return fetch(`/search/suggest.json?${params.toString()}`)
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data?.resources?.results?.collections || [];
    })
    .catch((err) => {
      console.log("Fetch errored or aborted:", err);
      return null;
    });
};

export const searchProducts = (query: string) => {
  const params = new URLSearchParams({
    q: query,
    "resources[type]": "product",
    "resources[limit]": "8",
    "resources[limit_scope]": "each",
  });
  return fetch(`/search/suggest.json?${params.toString()}`)
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data?.resources?.results?.products || [];
    })
    .catch((err) => {
      console.log("Fetch errored or aborted:", err);
      return null;
    });
};
